import { useEffect, useState } from "react";
import SelectMultipleGenericFilter from "../SelectMultipleGenericFilter";
import { GenericSkuFilterTypeId, SkuAvailabilityId } from "types/commonTypes";
import SelectGenericFilter from "../SelectGenericFilter";
import AttributesFilter from "../AttributesFilter";
import { CatalogFilter } from "services/organizationPortalClient";
import { CommonFilter, useIsFilterApplied } from "@knowfully/ui.common";

type HomeStudyCatalogFilterProps = {
  onChange: (filter: CatalogFilter) => void;
};

export default function HomeStudyCatalogFilter({
  onChange,
}: HomeStudyCatalogFilterProps) {
  const [filter, setFilter] = useState({} as CatalogFilter);

  const isFilterApplied = useIsFilterApplied(filter, []);

  const onChangeInternal = (prop: keyof CatalogFilter, val: any) => {
    setFilter((prev) => ({ ...prev, [prop]: val }) as CatalogFilter);
  };

  // Auto-apply filters to parent on any change
  useEffect(() => {
    onChange(filter);
  }, [filter, onChange]);

  const clearFilter = () => {
    const emptyFilter = {} as CatalogFilter;
    setFilter(emptyFilter);
  };

  return (
    <CommonFilter
      searchText={filter.searchText}
      onSearchTextChange={(val: string | undefined) => onChangeInternal("searchText", val)}
      onClear={clearFilter}
      isFilterApplied={isFilterApplied}
    >
      <SelectGenericFilter
        labelKey="creditHours"
        typeId={GenericSkuFilterTypeId.CreditHours}
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        gridSize={4}
        value={filter.creditHours}
        onChange={(value) => onChangeInternal("creditHours", value)}
      />
      <SelectGenericFilter
        labelKey="topic"
        typeId={GenericSkuFilterTypeId.Topic}
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        gridSize={4}
        value={filter.topicId}
        onChange={(value) => onChangeInternal("topicId", value)}
      />
      <SelectGenericFilter
        labelKey="instructor"
        typeId={GenericSkuFilterTypeId.Resource}
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        gridSize={4}
        value={filter.instructorId}
        onChange={(value) => onChangeInternal("instructorId", value)}
      />
      <SelectMultipleGenericFilter
        labelKey="states"
        typeId={GenericSkuFilterTypeId.State}
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        value={filter.stateIds}
        onChange={(value) => onChangeInternal("stateIds", value)}
      />
      <SelectGenericFilter
        labelKey="format"
        typeId={GenericSkuFilterTypeId.Format}
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        gridSize={4}
        value={filter.formatId}
        onChange={(value) => onChangeInternal("formatId", value)}
      />
      <SelectMultipleGenericFilter
        labelKey="professions"
        typeId={GenericSkuFilterTypeId.Profession}
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        value={filter.professionIds}
        onChange={(value) => onChangeInternal("professionIds", value)}
      />
      <SelectMultipleGenericFilter
        labelKey="accreditedBy"
        typeId={GenericSkuFilterTypeId.Qualification}
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        value={filter.qualificationIds}
        onChange={(value) => onChangeInternal("qualificationIds", value)}
      />
      <AttributesFilter
        skuAvailabilityIds={[SkuAvailabilityId.OnDemand]}
        value={filter.attributesFilters ?? []}
        onChange={(value) => onChangeInternal("attributesFilters", value)}
      />
    </CommonFilter>
  );
}
